<template>
    <main class="container_mobile" id="apropos_mobile">
        <section class="container_mobile__section_1">
            <article class="container_mobile__section_1__article">
                <aside class="container_mobile__section_1__article__aside_top">
                    <div class="container_mobile__section_1__article__aside_top__div">
                        <h1 class="container_mobile__section_1__article__aside_top__div__h1">
                            Apprendre à me connaitre
                        </h1>
                    </div>
                </aside>
                <aside class="container_mobile__section_1__article__aside_middle">
                    <div class="container_mobile__section_1__article__aside_middle__div_left">
                        <img src="@/assets/perfil_v1.jpg" alt="photo de profile"
                            class="container_mobile__section_1__article__aside_middle__div_left__img">
                    </div>
                    <!-- div right -->
                    <div class="container_mobile__section_1__article__aside_middle__div_right">
                        <p class="container_mobile__section_1__article__aside_middle__div_right__p">
                            Age : 22 ans
                            <br>
                            Ardèche (07)
                            <br>
                            Franco-suisse
                        </p>
                    </div>
                </aside>
                <aside class="container_mobile__section_1__article__aside_bottom">
                    <div class="container_mobile__section_1__article__aside_bottom__div">
                        <button class="container_mobile__section_1__article__aside_bottom__div__button">
                            <router-link
                                class="container_mobile__section_1__article__aside_bottom__div__button__router-link"
                                to="/error">
                                Mes realisations
                            </router-link>
                        </button>
                    </div>
                </aside>
            </article>
        </section>
        <!-- section 2 -->
        <section class="container_mobile__section_2">
            <article class="container_mobile__section_2__article">
                <aside class="container_mobile__section_2__article__aside_top">
                    <div class="container_mobile__section_2__article__aside_top__div">
                        <h1 class="container_mobile__section_2__article__aside_top__div__h1">
                            À mon sujet
                        </h1>
                    </div>
                </aside>
                <!--  -->
                <aside class="container_mobile__section_2__article__aside_bottom">
                    <div class="container_mobile__section_2__article__aside_bottom__div">
                        <!--  -->
                        <p class="container_mobile__section_2__article__aside_bottom__div__p_top">
                            Issue d'un Bac pro en dessin industriel. J'ai par la suite poursuivi mon cursus scolaire, en
                            effectuant
                            une année de BTS également en dessin industriel.
                        </p>
                        <!--  -->
                        <p class="container_mobile__section_2__article__aside_bottom__div__p_middle">
                            Ayant comme première vocation l'envie de rejoindre l'armée. C'est ce que je fis en 2019. Par
                            envie de
                            renouveau, j'ai quitté l'armée en 2021.

                        </p>
                        <!--  -->
                        <p class="container_mobile__section_2__article__aside_bottom__div__p_bottom">
                            J'ai eu l'opportunité d'effectuer une formation en développement web.
                        </p>
                        <!--  -->
                    </div>
                </aside>
            </article>
        </section>
        <section class="container_mobile__section_3">
            <article class="container_mobile__section_3__article">
                <aside class="container_mobile__section_3__article__aside_top">
                    <div class="container_mobile__section_3__article__aside_top__div">
                        <a href="https://github.com/jonathandu07"
                            class="container_mobile__section_3__article__aside_top__div__a">
                            <img src="@/assets/github-logo.png" alt="logo github"
                                class="container_mobile__section_3__article__aside_top__div__a__img">
                        </a>
                    </div>
                </aside>
                <aside class="container_mobile__section_3__article__aside_middle">
                    <div class="container_mobile__section_3__article__aside_middle__div">
                        <a href="https://www.linkedin.com/in/jonathan-yhwh/"
                            class="container_mobile__section_3__article__aside_middle__div__a">
                            <img src="@/assets/linkedin.png" alt="linkedin"
                                class="container_mobile__section_3__article__aside_middle__div__a__img">
                        </a>
                    </div>
                </aside>
                <aside class="container_mobile__section_3__article__aside_bottom">
                    <div class="container_mobile__section_3__article__aside_bottom__div">
                        <a href="https://drive.google.com/file/d/1sLzVVaHPmWRg0BOW2KNPa0h0uoAVAyi5/view?usp=sharing"
                            class="container_mobile__section_3__article__aside_bottom__div__a">
                            <h1 class="container_mobile__section_3__article__aside_bottom__div__a__h1">
                                CV
                            </h1>
                        </a>
                    </div>
                </aside>
            </article>
        </section>
        <section class="container_mobile__section_4">
            <article class="container_mobile__section_4__article">
                <!-- aside title -->
                <aside class="container_mobile__section_4__article__aside_top">
                    <div class="container_mobile__section_4__article__aside_top__div">
                        <h1 class="container_mobile__section_4__article__aside_top__div__h1">
                            Centres d'intérêts
                        </h1>
                    </div>
                </aside>
                <!-- aside text -->
                <aside class="container_mobile__section_4__article__aside_bottom">
                    <div class="container_mobile__section_4__article__aside_bottom__div">
                        <p class="container_mobile__section_4__article__aside_bottom__div__p">
                            Depuis mon plus jeune âge, je n'ai cessé de pratiquer du sport. Le plus récent, est la
                            pratique du tir
                            sportif.
                            Aimant créer divers choses et de nature "touche à tout", je me suis intéressé à la
                            programmation à partir
                            de mes 16ans.
                            La conception industriel est une des choses que j'ai pratiquer de manière précoce. Fan de
                            l'émission "Les
                            constructeurs de l'extrême". Je me plaisais à dessiner des avions et divers choses
                            techniques.
                            Naturellement je me suis tourné vers un bac pro dessin industriel.
                        </p>
                    </div>
                </aside>
            </article>
        </section>
        <section class="container_mobile__section_5">
            <!-- article title -->
            <article class="container_mobile__section_5__article_top">
                <aside class="container_mobile__section_5__article_top__aside_top">
                    <!-- div vide -->
                    <div class="container_mobile__section_5__article_top__aside_top__div_vide1">

                    </div>
                    <!-- div title -->
                    <div class="container_mobile__section_5__article_top__aside_top__div">
                        <h1 class="container_mobile__section_5__article_top__aside_top__div__h1">
                            Méthodologie
                        </h1>
                    </div>
                    <!-- div vide -->
                    <div class="container_mobile__section_5__article_top__aside_top__div_vide2">

                    </div>
                </aside>

                <aside class="container_mobile__section_5__article_top__aside_middle">
                    <div class="container_mobile__section_5__article_top__aside_middle__div">
                        <img src="@/assets/responsive.png" alt="responsive"
                            class="container_mobile__section_5__article_top__aside_middle__div__img" />
                    </div>
                </aside>

                <aside class="container_mobile__section_5__article_top__aside_bottom">
                    <div class="container_mobile__section_5__article_top__aside_bottom__div">
                        <p class="container_mobile__section_5__article_top__aside_bottom__div__p">
                            Des sites web responsives, adaptatifs, et flexibles. Il me tient à cœur de réaliser des
                            sites web design,
                            optimisés et fidèles aux désirs du client.
                        </p>
                    </div>
                </aside>
            </article>

            <article class="container_mobile__section_5__article_bottom">
                <!-- aside 3 left bottom -->
                <aside class="container_mobile__section_5__article_bottom__aside_top">
                    <!-- display grid -->
                    <div class="container_mobile__section_5__article_bottom__aside_top__div_1">
                        <img src="@/assets/psd_file.png" alt="photoshop logo"
                            class="container_mobile__section_5__article_bottom__aside_top__div_1__img" />
                    </div>

                    <div class="container_mobile__section_5__article_bottom__aside_top__div_2">
                        <img src="@/assets/adobe_illustrator.png" alt=" ilustrator logo"
                            class="container_mobile__section_5__article_bottom__aside_top__div_2__img">
                    </div>

                    <div class="container_mobile__section_5__article_bottom__aside_top__div_3">
                        <img src="@/assets/adobe_xd.png" alt="adobe xd logo"
                            class="container_mobile__section_5__article_bottom__aside_top__div_3__img">
                    </div>

                    <div class="container_mobile__section_5__article_bottom__aside_top__div_4">
                        <img src="@/assets/adobe_indesign.png" alt="Indesign logo"
                            class="container_mobile__section_5__article_bottom__aside_top__div_4__img">
                    </div>
                </aside>
                <!-- aside 4 right bottom -->
                <aside class="container_mobile__section_5__article_bottom__aside_bottom">
                    <!-- div top -->
                    <div class="container_mobile__section_5__article_bottom__aside_bottom__div_top">
                        <p class="container_mobile__section_5__article_bottom__aside_bottom__div_top__p">
                            Pour être au plus proche des besoins du clients, j'utilise les outils suivant : Photoshop,
                            Illustrator,
                            Adobe
                            XD et In Design.
                        </p>
                    </div>
                    <!-- div bottom -->
                    <div class="container_mobile__section_5__article_bottom__aside_bottom__div_bottom">
                        <p class="container_mobile__section_5__article_bottom__aside_bottom__div_bottom__p">
                            Également je me tient à jours des nouveautés.
                        </p>
                    </div>
                </aside>
            </article>
        </section>
    </main>
</template>

<script >
export default {
    name: 'AproposMobile',
}
</script>

<style  lang=scss scoped>


@import "@/style/components/Apropos/AproposMobile.scss";

@media screen and(min-width: 926px) {
    #apropos_mobile {
        display: none;
    }
}
</style>